package com.exura.features.plandefinition.domain.model.element

import dev.gitlive.firebase.firestore.CollectionReference

data class QuestionElement(
    override val firebaseDocId: String? = null,
    override val firebaseDocPrefix: CollectionReference? = null,
    override val relativeDay: Int,
    override val title: String,
    val question: String,
    val options: List<Option>,
    override val imageUrl: String? = null,
    override val durationInMinutes: Int = 5,
) : BasePlanElement(
    firebaseDocId = firebaseDocId,
    firebaseDocPrefix = firebaseDocPrefix,
    elementType = ElementType.QUESTION,
) {

    override fun durationInDays(): Int = 1

    data class Option(
        val id: String,
        val text: String,
        val responseMessage: String? = null,
        val isResponsePositive: Boolean = true,
    )
}
